import { Offer_Fulfillment_Operator } from '@occc/graphql';

export const getFulfilledInfo = (
  operator: Offer_Fulfillment_Operator | undefined | null,
  timesFulfilled: number | undefined | null,
) => {
  const operatorsMap = {
    [Offer_Fulfillment_Operator.IsEqualTo]: '',
    [Offer_Fulfillment_Operator.IsGreaterThan]: 'more than',
    [Offer_Fulfillment_Operator.IsGreaterThanOrEqualTo]: 'more than or',
    [Offer_Fulfillment_Operator.IsLessThan]: 'less than',
    [Offer_Fulfillment_Operator.IsLessThanOrEqualTo]: 'less than or',
  };

  return operator
    ? `Has fulfilled ${operatorsMap[operator]} ${timesFulfilled ?? ''} time${
        timesFulfilled && timesFulfilled > 1 ? 's' : ''
      }`
    : 'Has fulfilled';
};
